<template>
  <div v-if="isLoadingLists" class="d-flex justify-content-center align-items-center mt-5">
    <b-spinner variant="primary" label="Spinning" />
  </div>
  <validation-observer v-else ref="form" v-slot="{ invalid, errors }">
    <BForm class="py-2 placements-form" @submit.prevent="handleSubmit">
      <b-row>
        <b-col v-if="can('manage', 'placements-cpm')" cols="3" class="d-flex flex-column">

      <form-input id="static" class="w-100" @blur="setComission(formData.publisher_commission_static)" @input="setComissionLabel" v-model="formData.publisher_commission_static" :label="comissionLabel" type="number" vid="static" :rules="validationSchema.comission_static" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <BFormCheckbox v-model="formData.priority_by_income">Автоприоритет по доходности</BFormCheckbox>
        </b-col>
      </b-row>
      <b-row class="min-height-360 mt-2 campaign-form__multiselect">
        <b-col class="campaign-form__multiselect-leftcol" id="to-filter" sm="3">
          <ToFilterSelect :model-value="filterToShow" @update:model-value="setFilterToShow"
                          :proxy-names="proxyForFilterSelect"
                          :filters-options="filtersOptions" :state="formData" :errors="errors"
                          :facets="namedLists" />
        </b-col>

        <b-col v-show="filterToShow === 'platforms'" class="placements-form__select-col">
          <b-row class="d-flex" style="gap: 20px">
            <div class="col pr-0 mt-1 mt-md-0">
            <form-input-wrap
                id="platform_id"
                vid="platform_id"
                class="w-100"
                label="Площадка"
                label-hidden
                :rules="validationSchema.platform"
            >
            <MultiselectCheckboxesWithValidation
                class="flex-1-1-0"
                name="platform_id"
                :model-value="formData.platform_id"
                @update:model-value="pickMultiselect($event, 'platform_id')"
                :facets="platformsList"
                v-model="formData.platform_id"
                :state="formData.platform_id"
                single
                track-by="id"
                is-paginated
                :lists="namedLists"
                @paginate="handlePaginateList"
                @search="handleListsSearch"/>
            </form-input-wrap>
            </div>
          </b-row>
        </b-col>

        <b-col v-if="can('read', 'publishers-list')" v-show="filterToShow === 'publishers'" class="placements-form__select-col">
          <b-row class="d-flex" style="gap: 20px">
            <div class="col pr-0 mt-1 mt-md-0">
            <MultiselectCheckboxesWithValidation
                class="flex-1-1-0"
                name="publisher_id"
                :facets="publishersList"
                :model-value="publisher_id"
                @update:model-value="pickPublisher($event, 'publisher_id')"
                single
                track-by="id"
                is-paginated
                :lists="namedLists"
                @paginate="handlePaginateList"
                @search="handleListsSearch"/>
            </div>
          </b-row>
        </b-col>

        <b-col v-show="filterToShow === 'advertisement_types'" class="placements-form__select-col">
          <b-row class="d-flex" style="gap: 20px">
            <div class="col pr-0 mt-1 mt-md-0">
            <form-input-wrap
                id="advertisement_types"
                vid="advertisement_types"
                class="w-100"
                label="Тип рекламы"
                label-hidden
                :rules="validationSchema.advertisement_types"
            >
            <MultiselectCheckboxesWithValidation
                class="flex-1-1-0"
                name="advertisement_types"
                :facets="advertisementTypesList"
                v-model="formData.advertisement_types"
                :state="formData.advertisement_types"
                :model-value="formData.advertisement_types"
                @update:model-value="pickAdvertisementTypes($event, 'advertisement_types')"
                :disable-method="disableForAdvertisementType"
                track-by="id"
                :is-searchable="false"/>
            </form-input-wrap>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </BForm>
  </validation-observer>
</template>

<script>
import ToFilterSelect from "@/components/ToFilterSelect"
import {dynamicRegex} from "@core/utils/validations/validators"
import MultiselectCheckboxesWithValidation from "@/components/MultiselectCheckboxesWithValidation"
import {
  BForm,
  BButton,
  BFormSelect,
  BFormInput,
  BFormSelectOption,
  BFormTextarea,
  BBadge,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BFormRadio,
  BFormGroup,
  BFormCheckbox
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import FormInput from '@/components/FormInput'
import FormInputWrap from '@/components/FormInputWrap'
import LoaderButton from '@/components/LoaderButton'
import MultipleSelect from '@/components/MultipleSelect'
import Multiselect from 'vue-multiselect'

import * as validations from '@validations'
import { ValidationProvider } from 'vee-validate'
import {
  fetchAdvertisementType, fetchPlatformsList
} from '@/api/lists'
import MultiselectValidation from "@/components/MultiselectWithValidation"
import {useUtils as useAclUtils} from "@core/libs/acl"
import {objToQuery} from "@core/utils/utils"
import statisticLists from "@/use/statisticLists"
import {ref} from "@vue/composition-api/dist/vue-composition-api"
import {reactive} from "@vue/composition-api"


export default {
  name: 'MultiPlacementForm',
  components: {
    MultiselectValidation,
    ToFilterSelect,
    MultiselectCheckboxesWithValidation,
    ValidationProvider,
    BFormCheckbox,
    BForm,
    BFormInput,
    BFormRadio,
    BFormGroup,
    BButton,
    BFormSelect,
    BFormTextarea,
    BFormSelectOption,
    BBadge,
    BDropdown,
    BDropdownItem,
    BSpinner,
    ValidationObserver,
    FormInput,
    FormInputWrap,
    LoaderButton,
    MultipleSelect,
    Multiselect,
  },

  setup() {

    const {
      platformsList,
      advertisementTypesList,
      advertisersList,
      publishersList,
      namedLists,
      handleListsSearch,
      handleLoadLists,
      handlePaginateList,
      setQuery,
      getQuery
    } = statisticLists()

    const { can } = useAclUtils()
    const isLoadingLists = ref(true)
    const filterToShow = ref('platforms')

    const publisher_id = ref([])
    const formData = reactive({
      name: '',
      platform_id: [],
      advertisement_types: [],
      publisher_commission_static: null,
      priority_by_income: false,
      publisher_commission_dynamic: null,
      must_verify_traffic: false,
      campaigns: [],
    })

    const form = ref(null);
    const comissionType = ref('static');

    let filtersOptions = [
      {
        text: 'Площадка',
        value: 'platforms'
      },
      {
        text: 'Тип рекламы',
        value: 'advertisement_types'
      },
    ]

    const proxyForFilterSelect = {
      platforms: 'platform_id',
      advertisement_types: 'advertisement_types',
    }

    let toLoadLists = ['platforms']

    const addRolesOptions = () => {
      if(can('read', 'publishers-list')) {
        filtersOptions.unshift({
          text: 'Паблишер',
          value: 'publishers'
        })
        toLoadLists.push('publishers');
      }
    }

    addRolesOptions()

    handleLoadLists(toLoadLists, isLoadingLists)

    filterToShow.value = filtersOptions[0].value


    fetchAdvertisementType()
      .then(value => {
        advertisementTypesList.value = value.data.data
      })


    const setFilterToShow = (value) => {
      filterToShow.value = value;
    }

    const comissionLabel = ref('CPM')

    const setComissionLabel = (val) => {
      comissionLabel.value = dynamicRegex.test(val) ? 'Динамический CPM' : 'Статический CPM'
    }

    const setComission = (value) => {
      if(dynamicRegex.test(value)) return;
    }


    const pickMultiselect = (value, name) => {
      formData[name] = value;
    }

    const pickPublisher = (value, name) => {
      publisher_id.value = value;
      formData.platform_id = null;
      isLoadingLists.value = true;

      updatePlatforms()
    }

    const pickAdvertisementTypes = (value, name) => {
      formData[name] = value;
    }

    const updatePlatforms = () => {
      fetchPlatformsList(objToQuery({'publisher': [publisher_id.value]}))
          .then((res) => {
            platformsList.value = res.data.data
          })
          .finally(() => {
            isLoadingLists.value = false;
          })
    }

    const disableForAdvertisementType = (el) => {
      if(formData.advertisement_types.length === 0) return false;
      switch(el.id){
        case 1:
        case 2:
          if(formData.advertisement_types.includes(3) || formData.advertisement_types.includes(4)) {
            return true
          }
          break;
        case 3:
          if(formData.advertisement_types.includes(1) || formData.advertisement_types.includes(2) || formData.advertisement_types.includes(4))
            return true
          break;
        case 4:
          if(formData.advertisement_types.includes(1) || formData.advertisement_types.includes(2) || formData.advertisement_types.includes(3))
            return true
          break;
        default:
          if(formData.advertisement_types.includes(1) || formData.advertisement_types.includes(2)) return true
          break;
      }
    }

    const handleSubmit = () => {}

    const validate = () => form.value.validate()

    const getRequestData = () => {
      const requestData = {
        ...formData,
        publisher_commission_static: dynamicRegex.test(formData.publisher_commission_static) ? null : formData.publisher_commission_static.replace(',', '.'),
        publisher_commission_dynamic: dynamicRegex.test(formData.publisher_commission_static) ? formData.publisher_commission_static.slice(0, -1) : null
      }

      for (let prop in requestData) {
        if (Array.isArray(requestData[prop]) && requestData[prop].length) {
          requestData[prop] = requestData[prop].join(',')
        }
      }

      return requestData
    }


    return {
      can,
      isLoadingLists,
      pickMultiselect,
      proxyForFilterSelect,
      comissionType,
      form,
      pickPublisher,
      handleSubmit,
      validate,
      getRequestData,
      disableForAdvertisementType,
      pickAdvertisementTypes,
      publisher_id,
      setComission,
      formData,
      platformsList,
      advertisersList,
      advertisementTypesList,
      publishersList,
      namedLists,
      handleListsSearch,
      handleLoadLists,
      handlePaginateList,
      filterToShow,
      filtersOptions,
      ...validations,
      setFilterToShow,
      comissionLabel,
      setComissionLabel
    }
  },
  props: {
    validationSchema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      comissionCheck: false,
      showPlatformTooltip: false,
    }
  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

.placements-form {
  & .multiselect {

    &__items {
      height: 150px;
    }
  }

  &__select-col {
    padding-right: 2rem;
  }
}

.campaign__dropdown {
  width: 100%;
}

.campaign__dropdown .dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.selected-item {
  margin: 3px;
  cursor: pointer;
}

.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px;
}
</style>
